import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS } from "@contentful/rich-text-types";
import * as React from "react";
import ButtonLink from "./button-link";
import Link from "./link";

const renderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const [{ value }] = node.content;

      if (value !== "" || node.content.length > 1) {
        return <p>{children}</p>;
      }

      return null;
    },
  },

  renderText: (text) => {
    return text
      .split("\n")
      .flatMap((text, index) => [index > 0 && <br key={index} />, text]);
  },
};

const Banner = ({
  heading,
  text,
  active,
  link,
  linkText,
  large,
  product,
  buttonLink,
}) => {
  const largeClass = large ? " banner-large" : "";
  const productClass = product ? " banner-product" : "";

  if (!active) return null;

  return (
    <section
      className={`banner${largeClass}${productClass}`}
      aria-labelledby="banner-heading"
    >
      <div className="container">
        <div>
          <h2
            id="banner-heading"
            className={`heading${large ? " heading-large" : ""}`}
            dangerouslySetInnerHTML={{ __html: heading }}
          />
          {text && renderRichText(text, renderOptions)}
          {link && (
            <Link href={link} className="banner-link">
              {linkText}
            </Link>
          )}
          {buttonLink && (
            <ButtonLink
              href={buttonLink.link}
              button={buttonLink.button}
              target={buttonLink.target}
              modal={buttonLink.modal}
              className="banner-button"
            >
              {buttonLink.title}
            </ButtonLink>
          )}
        </div>
      </div>
    </section>
  );
};

export default Banner;
